import React, {Component} from 'react';
import avatar from '../../../views/pages/images/user.jpeg';
import {Link} from 'react-router-dom';
import screenfull from 'screenfull';
import {
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Button
} from 'reactstrap';
import NotificationSystem from 'react-notification-system';
// icons
import IconNotification from 'react-icons/lib/md/notifications-none';
import IconFullScreen from 'react-icons/lib/md/crop-free';
// import IconSearch from 'react-icons/lib/md/search';
// import IconFace from 'react-icons/lib/md/face';
import IconSecurity from 'react-icons/lib/md/security';
// import IconHelp from 'react-icons/lib/md/help';
import IconLogout from 'react-icons/lib/md/power-settings-new';
import IconMenu from 'react-icons/lib/md/menu';
import { connect } from "react-redux";
import moment from 'moment';
// import { commonService } from "../../../_services";
import Notification from "../notification";

// style
import './style.css';
import {appHelpers} from "../../../_helpers";
import {appConstants} from "../../../_constants";
// import {alertActions} from "../../../_actions/alert.actions";
// import {apiActions} from "../../../_actions/api.actions";

class HeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manifestPullModesStartDate: moment().subtract(1, 'day'),
            manifestPullModesEndDate: moment(),
            pullModes: [], //pull mode array that is populated in getManifestPullMode method
            manifestStatusStartDate: moment().subtract(1, 'day'),
            manifestStatusEndDate: moment(),
            manifestProcessSuccess: [],  //successfully processed manifests array that is populated in the getManifestProcessedStatus method
            interval: 1,
            intervalId: null,
            processSuccessful: null,
            processFailed: [],
            manifestStatus: [],
            count: 0,
            openModal: false,
            dropdownOpen: false,
            showNotifications: true,
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            }
        };
        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        // let { interval } = this.state;

        // this.getManifestPullModes();
        // this.getManifestProcessedStatus();

        //set interval method that fetches new notification records at different intervals.
        // const intervalId = setInterval(() => {
        //     this.getNotificationUpdate()
        // }, interval * 1000 * 60);

        // this.setState({intervalId}) //intervalId stored in state that is used to clear the setInterval method.

    }

    // getNotificationUpdate = () => {
    //     const  { interval, intervalId, pullModes, manifestStatus } = this.state;
    //     const { dispatch } = this.props;

    //     //payload to send to individual endpoints to get Notification record. start date is set to the present date and a minute before the request
    //     const payload = {
    //         startDate: moment().subtract(1, 'hour').format("YYYY-MM-DDTHH:mm"),
    //         endDate: moment().format("YYYY-MM-DDTHH:mm")
    //     };

    //     //call to endpoint to get current notification record.
    //     Promise.all([
    //         commonService.searchManifestPullModes(payload),
    //         commonService.searchManifestStatus(payload),

    //     ]).then(response => {
    //         //If a new record is found, pass the necessary arguments to the setNotificationRecords endpoint to update individual notification records in state.
    //         const foundNewPullModeRecord = this.setNotificationRecords(response[0].response.summary, pullModes, "pullModes");
    //         const foundNewProcessSuccessfulRecord = this.setNotificationRecords( response[1].response.summary, manifestStatus, "manifestStatus");

    //         if(!foundNewPullModeRecord || !foundNewProcessSuccessfulRecord){    //If no new record is found,
    //             this.setState({foundNewRecord: false});
    //             clearInterval(intervalId);     //stop the clearIntervalMethod on componentDidMount using its ID.
    //             const intervalTimer = (interval === 1) ? 2 : (interval === 2) ? 3 : 1;    //variable that holds the condition that changes the interval. First change the  interval to 10 minutes, then 20 minutes, then 30minutes. return to 10minutes and repeat the cycle until a record is found.
    //             const newIntervalId = setInterval(() => {  //recursively reset the setInterval method and pass the intervalTimer as the new time.
    //                 this.getNotificationUpdate();
    //             }, intervalTimer * 1000 * 30);
    //             this.setState({interval: intervalTimer, intervalId: newIntervalId}); //update interval and intervalId in state.
    //             // console.log({intervalId, payload, intervalTimer});

    //         }
    //     }).catch(err => {
    //         let errorMessage = appHelpers.interpretErrorResponse(err);
    //         this.notify(errorMessage, appConstants.NOTIFY_ERROR);
    //         dispatch(apiActions.endRequest());
    //     })
    // };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };
    // method to set individual Notification records in state. The arguments (summary = array object from endpoint record. arr = array we want to update. stateIndentifier = identifies the array in state we want to update)
    setNotificationRecords = (summary, arr, stateIdentifier) => {
        const summaryKeys = Object.keys(summary);
        // console.log({summaryKeys});

        let newNotificationRecord = false;   //There is no new notification record by default

        //higher-order function that pushes an object into the Notification array.
        summaryKeys.forEach(item => {
            if(summary[item] > 0 && summary[item] !== arr[item]) {      // if there is a new Notification Record
                newNotificationRecord = true;
                arr.unshift({     //add new notification to the notification array
                    name: item,
                    value: summary[item]
                })
                this.playSound()
            }
        });

        this.setState({[stateIdentifier] : arr,  showNotifications: true, count: this.state.pullModes.length + this.state.manifestStatus.length}); //set the individual array in state to the new notification array
        return newNotificationRecord;
    };

    setInitialNotificationRecord = (summary, stateIdentifier) => {
        let summaryKeys = Object.keys(summary);
        let NotificationRecord = [];

        summaryKeys.forEach(item => {
            if(summary[item] > 0) {
                NotificationRecord.push({
                    name: item,
                    value: summary[item]
                })
            }
        });

        this.setState({[stateIdentifier]: NotificationRecord});
    };

    //method to get manifest pull modes
    // getManifestPullModes = () => {
    //     let { manifestPullModesStartDate, manifestPullModesEndDate} = this.state;
    //     //payload for searchManifestPullModes endpoint
    //     let payload = {
    //         startDate: manifestPullModesStartDate.format("YYYY-MM-DDTHH:mm"),
    //         endDate:  manifestPullModesEndDate.format("YYYY-MM-DDTHH:mm")
    //     };

    //     const { dispatch } = this.props;

    //     //call to endpoint to get manifest pull modes
    //     commonService.searchManifestPullModes(payload)
    //         .then(res => {
    //             if (res.status === appConstants.SUCCESS_RESPONSE) {
    //                 let summary = res.response.summary;
    //                 let summaryKeys = Object.keys(res.response.summary);
    //                 let pullModes = [];

    //                 //higher-order function that pushes an object into the pullModes array.
    //                 summaryKeys.forEach(item => {
    //                     if(summary[item] > 0) {
    //                          pullModes.push({
    //                             name: item,
    //                             value: summary[item]
    //                         });
    //                         this.playSound();
    //                     }
    //                 });

    //                 this.setState({pullModes},
    //                     () => this.setState({count: this.state.pullModes.length + this.state.manifestStatus.length})); //set the value of pullModes array in state to pullModes and update count


    //             } else if (res.status === appConstants.ERROR_RESPONSE) {
    //                 dispatch(alertActions.error(res.response));
    //             }
    //         })
    // };

    //method to get manifests processed successfully to display on notifications
    // getManifestProcessedStatus = () => {
    //     let { manifestStatusStartDate, manifestStatusEndDate} = this.state;

    //     let payload = {
    //         StartDate: moment(manifestStatusStartDate).format('YYYY-MM-DD') + "T00:00:00",
    //         EndDate:  moment(manifestStatusEndDate).format('YYYY-MM-DD') + 'T23:59:59'
    //     };

    //     // let newNotificationRecord = false;

    //     // let totalNotifications = 0; // Number of notifications

    //     const { dispatch } = this.props;

    //     commonService.searchManifestStatus(payload)
    //         .then(res => {
    //             if (res.status === appConstants.SUCCESS_RESPONSE) {
    //                 let summary = res.response.summary;
    //                 let summaryKeys = Object.keys(res.response.summary);
    //                 let manifestStatus = [];

    //                 summaryKeys.forEach((item) => {
    //                     if(summary[item] > 0) {
    //                         // totalNotifications = i;
    //                          manifestStatus.push({
    //                             name: item,
    //                             value: summary[item]
    //                         });
    //                         this.playSound();
    //                     }
    //                 });

    //                 this.setState({manifestStatus},
    //                     () => this.setState({count: this.state.pullModes.length + this.state.manifestStatus.length}, () => this.playSound()));

    //             } else if (res.status === appConstants.ERROR_RESPONSE) {
    //                 dispatch(alertActions.error(res.response));

    //             }
    //         })
    // };

    // setManifestProcess= (summary, stateIdentifier) => {
    //     let newNotificationRecord = false;

    //     let newProcessSuccessful = [];
    //     if (summary > 0) {
    //         newNotificationRecord = true;
    //         newProcessSuccessful.unshift(summary);
    //         this.setState({ processSuccessful: newProcessSuccessful })
    //     }
    //     return newNotificationRecord
    // };

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    };

    clearNotifications = () => {
        const {manifestStatus} = this.state;

        manifestStatus.splice(0, manifestStatus.length);

        this.setState({showNotifications: false, count: 0})
    };

    // playSound = () => {
    //     let sound = document.getElementById("audio");
    //     sound.play();
    // };

    render() {
        const { pullModes, manifestStatus, count, showNotifications} = this.state;
        const activeUser = appHelpers.getActiveUser();
        const props = this.props;
        return (
            <header className="site-head d-flex align-items-center justify-content-between">
                {/* <audio id="audio" src="http://www.soundjay.com/misc/small-bell-ring-01a.wav" autostart="false" ></audio> */}
                <div className="wrap mr-4">
                    <IconMenu size="24" color="#fff" onClick={props.toggleNav} style={{cursor: 'pointer'}}/>
                </div>
                {/*<form className="col-7 col-sm-8 col-md-7 p-0 site-search">
                <IconSearch color="#515151" size="22"/>
                <input type="text" placeholder="Type your search ..." className="form-control"/>
            </form>*/}
                <div className="right-elems ml-auto d-flex">
                    <div className="wrap hidden-sm-down">
                        <IconFullScreen size="22" color="#fff" onClick={() => screenfull.toggle()}/>
                    </div>
                    {
                        <div className="wrap notify hidden-sm-down">
                            <UncontrolledDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                                <DropdownToggle tag="div">
                                    <IconNotification size="22" color="#fff" />
                                    { count > 0 &&
                                    <span className="badge badge-danger" onClick={() => this.playSound()}>{count}</span>
                                    }
                                </DropdownToggle>

                                <DropdownMenu right style={{minWidth: '18rem', maxHeight: '300px'}}
                                              modifiers={{
                                                  setMaxHeight: {
                                                      enabled: true,
                                                      order: 890,
                                                      fn: (data) => {
                                                          return {
                                                              ...data,
                                                              styles: {
                                                                  ...data.styles,
                                                                  overflow: 'auto',
                                                                  maxHeight: 300,
                                                              },
                                                          };
                                                      },
                                                  },
                                              }}
                                >
                                    <DropdownItem header>
                                        {
                                            (count > 0 ) ?
                                                `You have ${count} new notifications`
                                                :
                                                `You have no new notification`
                                        }
                                    </DropdownItem>
                                    <DropdownItem divider/>
                                    {
                                        showNotifications&&
                                        pullModes &&
                                        pullModes.map(item => {
                                            return <Notification
                                                notificationType={appConstants.NOTIFICATION_TYPES.PULL_MODE}
                                                pullModeValue={item.value}
                                                pullModeName={item.name}

                                            />

                                        })

                                    }
                                    {
                                        showNotifications &&
                                        manifestStatus &&
                                        manifestStatus.map(item => {
                                            if (item.name === "Successful") {

                                                return <Notification
                                                    notificationType={appConstants.NOTIFICATION_TYPES.MANIFEST_SUCCESS}
                                                    manifestStatusValue={item.value}
                                                />
                                            } else if (item.name === "Failed") {
                                                return <Notification
                                                    notificationType={appConstants.NOTIFICATION_TYPES.MANIFEST_FAILED}
                                                    manifestStatusValue={item.value}
                                                />
                                            } else if (item.name === "Pending") {
                                                return <Notification
                                                    notificationType={appConstants.NOTIFICATION_TYPES.MANIFEST_PENDING}
                                                    manifestStatusValue={item.value}
                                                />
                                            } else if (item.name === "Processing") {
                                                return <Notification
                                                    notificationType={appConstants.NOTIFICATION_TYPES.MANIFEST_PROCESSING}
                                                    manifestStatusValue={item.value}
                                                />
                                            } else if (item.name === "Partial") {
                                                return <Notification
                                                    notificationType={appConstants.NOTIFICATION_TYPES.MANIFEST_PARTIAL}
                                                    manifestStatusValue={item.value}
                                                />
                                            } else {
                                                return <Notification />
                                            }
                                        })

                                    }

                                    {
                                        count > 0 &&
                                        <div className={"mr-4 mt-2 text-right"}>
                                            <Button className={"btn-avi-primary"} onClick={this.clearNotifications}> Clear All</Button>
                                        </div>
                                    }
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    }

                    <div className="wrap profile">
                        <UncontrolledDropdown>
                            <DropdownToggle tag="div">
                                <img src={avatar} alt="avatar"/>
                            </DropdownToggle>
                            <DropdownMenu right style={{minWidth: '12rem'}}>
                                <DropdownItem header>
                                    {
                                        (activeUser) &&
                                        <span className={'text-capitalize'}>
                                    {activeUser.fullName}
                                </span>
                                    }
                                </DropdownItem>
                                <DropdownItem divider/>
                                <div className='pointer dropdown-item'>
                                <span onClick={() => props.processForgotPassword()} className='pointer'>
                                <IconSecurity size="16"/> Reset Password
                            </span>
                                </div>
                                {/*<DropdownItem><IconFace size="16"/>&emsp;<a href="#na">Profile</a></DropdownItem>*/}

                                {/*<DropdownItem><IconHelp size="16"/>&emsp;<a href="#na">Help</a></DropdownItem>*/}
                                <div className="text-right ml-3 mr-3 mt-2">
                                    <Link to="/signin"><Button block color="success" size="sm"><IconLogout size="15"/>&emsp;Logout</Button></Link>
                                </div>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>
                <NotificationSystem ref="notificationSystem"/>
            </header>

        );
    }
}

// = (props) => {
//     const activeUser = appHelpers.getActiveUser();
//     return (
//         <header className="site-head d-flex align-items-center justify-content-between">
//             <div className="wrap mr-4">
//                 <IconMenu size="24" color="#fff" onClick={props.toggleNav} style={{cursor: 'pointer'}}/>
//             </div>
//             {/*<form className="col-7 col-sm-8 col-md-7 p-0 site-search">
//                 <IconSearch color="#515151" size="22"/>
//                 <input type="text" placeholder="Type your search ..." className="form-control"/>
//             </form>*/}
//             <div className="right-elems ml-auto d-flex">
//                 <div className="wrap hidden-sm-down">
//                     <IconFullScreen size="22" color="#fff" onClick={() => screenfull.toggle()}/>
//                 </div>
//                 {
//
//             <div className="wrap notify hidden-sm-down">
//
//                 <UncontrolledDropdown>
//                     <DropdownToggle tag="div">
//                         <IconNotification size="22" color="#fff"/>
//                         <span className="badge badge-danger">4</span>
//                     </DropdownToggle>
//
//                     <DropdownMenu right style={{minWidth: '18rem'}}>
//                         <DropdownItem header>You have 4 new notifications</DropdownItem>
//                         <DropdownItem divider/>
//                         <DropdownItem className="mb-2">
//                             <p>Server Upgrade Required</p>
//                             {/*<Progress value={70} color="danger" style={{height: '3px'}}/>*/}
//                         </DropdownItem>
//                         <DropdownItem className="d-flex align-items-center">
//                             <IconDownload size="28" className="text-success"/>
//                             <div className="ml-3">
//                                 <div>5 App Downloaded</div>
//                                 <small className="text-muted">5 min ago</small>
//                             </div>
//                         </DropdownItem>
//                         <DropdownItem className="d-flex align-items-center">
//                             <IconMail size="28" className="text-warning"/>
//                             <div className="ml-3">
//                                 <div>Roni sent you a message</div>
//                                 <small className="text-muted">2 hours ago</small>
//                             </div>
//                         </DropdownItem>
//                         <DropdownItem className="d-flex align-items-center">
//                             <IconCake size="28" className="text-primary"/>
//                             <div className="ml-3">
//                                 <div>You're earned a badge</div>
//                                 <small className="text-muted">12 hours ago</small>
//                             </div>
//                         </DropdownItem>
//                     </DropdownMenu>
//                 </UncontrolledDropdown>
//             </div>
// }
//
//                 <div className="wrap profile">
//                     <UncontrolledDropdown>
//                         <DropdownToggle tag="div">
//                             <img src={avatar} alt="avatar"/>
//                         </DropdownToggle>
//                         <DropdownMenu right style={{minWidth: '12rem'}}>
//                             <DropdownItem header>
//                                 {
//                                     (activeUser) &&
//                                     <span className={'text-capitalize'}>
//                                     {activeUser.fullName}
//                                 </span>
//                                 }
//                             </DropdownItem>
//                             <DropdownItem divider/>
//                             <div className='pointer dropdown-item'>
//                                 <span onClick={() => props.processForgotPassword()} className='pointer'>
//                                 <IconSecurity size="16"/> Reset Password
//                             </span>
//                             </div>
//                             {/*<DropdownItem><IconFace size="16"/>&emsp;<a href="#na">Profile</a></DropdownItem>*/}
//
//                             {/*<DropdownItem><IconHelp size="16"/>&emsp;<a href="#na">Help</a></DropdownItem>*/}
//                             <div className="text-right ml-3 mr-3 mt-2">
//                                 <Link to="/signin"><Button block color="success" size="sm"><IconLogout size="15"/>&emsp;Logout</Button></Link>
//                             </div>
//                         </DropdownMenu>
//                     </UncontrolledDropdown>
//                 </div>
//             </div>
//         </header>
//
//     );
// };

function mapStateToProps(state, ownProps) {
    const { loggingIn, user } = state.authentication;
    const { pageRequesting, requesting } = state.api;
    const { airlinesCarriers, alert } = state;
    return {
        loggingIn,
        airlinesCarriers,
        requesting,
        pageRequesting,
        user,
        alert
    }

}

export default connect(mapStateToProps)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/shared/components/header/index.js